import { Employees } from '~/data/employees';
import { getFormattedEmploymentValue } from '~/scenes/PeopleModule/components/Tabs/BasicTab/components/EmploymentDataForm/data';

export type InternalPositionTranslateData = {
  fPositionFK: string;
  fManagerFK: number;
  fCostCenterPct: string;
  fInfo: string;
  fStartDate: string;
  fEndDate: string;
  fJobTitle: string;
};

export type ResolvedInternalPositionData = {
  position: string;
  manager: string;
  costCenterPercentage: string;
  info: string;
  startDate: string;
  endDate: string;
  jobTitle: string;
};

export const resolveInternalPositionTranslatedData = (
  translate: InternalPositionTranslateData,
  getEmployeeById: (employeeId?: number) => Employees | undefined,
): ResolvedInternalPositionData => {
  const manager = getEmployeeById(translate.fManagerFK);
  const managerName = manager
    ? `${manager.fEmpLastName}, ${manager.fEmpFirstName}`
    : '';

  return {
    position: getFormattedEmploymentValue(translate.fPositionFK, '_', ' '),
    manager: managerName,
    costCenterPercentage: translate.fCostCenterPct,
    info: translate.fInfo,
    startDate: translate.fStartDate,
    endDate: translate.fEndDate,
    jobTitle: translate.fJobTitle,
  };
};
